import { selector, selectorFamily, useRecoilValue } from 'recoil';
import _ from 'lodash';
import { UserService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { User } from 'types';

export const users = selectorFamily<User[], string | undefined>({
    key: 'users',
    get: (isInternal) => 
        async ({ get }) => {
        get(refreshState(users(isInternal).key));
        const auth = get(isAuthenticated);
        if (auth) {
            const service = new UserService();
            let data = await service.getUsers(isInternal);
            if (!_.isArray(data)) {
                data = _.get(data, 'users', []);
            }
            return data.map(user => {
                const fullName = (user.firstName && user.lastName) && `${user.firstName} ${user.lastName}`;

                let mappedUser = {
                    ...user,
                    fullName: user.fullName ?? fullName ?? user.emailAddress,             
                } as User;

                return mappedUser;
            });
        }
        return [];
    }
});

export const currentUser = selector<User | null>({
    key: 'currentUser',
    get: async  ({ get }) => {
        get(refreshState(currentUser.key));
        if (get(isAuthenticated)) {
            const service = new UserService();
            const userData = await service.getCurrentUser();
            const fullName = (userData?.firstName && userData?.lastName) && `${userData.firstName} ${userData.lastName}`;
            return {
                ...userData,
                fullName: userData?.fullName ?? fullName,
            };
        }
        return null;
    }
})

export const internalUsers = selector<User[]>({
    key: 'internalUsers',
    get: async ({ get }) => {
        return get(users('true'));
    }
});

export const useCurrentUser = () => useRecoilValue(currentUser);

export const useInternalUsers = () => useRecoilValue(internalUsers);

export const useUsers = (isInternal?: string) => useRecoilValue(users(isInternal));

export const useRefreshUsers = (isInternal?: string) => useSetRefreshState(users(isInternal));